import React, { useState, useEffect } from 'react';
import { useNavigate, useLocation, Link } from 'react-router-dom';
import { Container, Row, Col, Card, Dropdown, Modal, Button, ProgressBar } from 'react-bootstrap';
import GlobalIpModal from './GlobalIpModal';
import APP_VERSION from '../config/version';

const Home = () => {
  const navigate = useNavigate();
  const [username, setUsername] = useState('Administrator');
  const [menus, setMenus] = useState([]);
  const [activeMenu, setActiveMenu] = useState('');
  const [hoveredInfo, setHoveredInfo] = useState(null);
  const [hoveredSubmenu, setHoveredSubmenu] = useState(null);
  const [time, setTime] = useState({ date: '', clock: '' });
  const [allSubMenus, setAllSubMenus] = useState([]);
  const [showGlobalIpModal, setShowGlobalIpModal] = useState(false);
  const [showBedModal, setShowBedModal] = useState(false);
  const [showPatientModal, setShowPatientModal] = useState(false);
  const [showVersionModal, setShowVersionModal] = useState(false);
  const [isNavOpen, setIsNavOpen] = useState(false);
  // eslint-disable-next-line no-unused-vars
  const location = useLocation();

  // Data Statistik Pasien & Tempat Rawat
  const bedStats = {
    total: 180,
    filled: 142,
    available: 38,
    classes: [
      { class: 'VVIP / VIP', total: 15, filled: 11, available: 4, color: '#8b5cf6' },
      { class: 'Kelas 1', total: 35, filled: 27, available: 8, color: '#0284c7' },
      { class: 'Kelas 2', total: 50, filled: 39, available: 11, color: '#0d9488' },
      { class: 'Kelas 3', total: 80, filled: 65, available: 15, color: '#16a34a' },
    ]
  };

  // State Pasien Rawat Jalan dari show_pasienrj
  const [rawatJalanCount, setRawatJalanCount] = useState(0);

  const patientStats = {
    total: 98 + rawatJalanCount,
    rawatInap: 98,
    rawatJalan: rawatJalanCount,
    igdToday: 18,
    departments: [
      { name: 'Penyakit Dalam', count: 32 },
      { name: 'Bedah Umum', count: 24 },
      { name: 'Anak & Perinatologi', count: 19 },
      { name: 'Kebidanan & Kandungan', count: 15 },
      { name: 'Saraf', count: 8 },
    ]
  };

  useEffect(() => {
    const savedUser = localStorage.getItem('nama_user') || localStorage.getItem('user');
    if (savedUser) setUsername(savedUser);

    const savedMenu = localStorage.getItem('mainmenu');
    if (savedMenu) {
      const parsedMenu = JSON.parse(savedMenu);
      setMenus(parsedMenu);
    }

    const savedSubMenu = localStorage.getItem('submenu');
    if (savedSubMenu) {
      try {
        let parsedSubMenu = JSON.parse(savedSubMenu);
        // Pastikan menu 0511 (Master Barang | Obat) selalu tersedia dengan lnk /MasterObat
        const hasMasterObat = parsedSubMenu.some(s => s.id_mm === '0511' || (s.lnk && s.lnk.toLowerCase().includes('masterobat')));
        if (!hasMasterObat) {
          parsedSubMenu.push({
            id_mm: '0511',
            id_mn: '05',
            nama: 'Master Barang | Obat',
            des_mn: 'Master Barang | Obat',
            nm_mm: 'Master Barang | Obat',
            lnk: '/MasterObat',
            icon: 'bi-capsule',
            info: 'Master Katalog Barang & Obat Apotek'
          });
          localStorage.setItem('submenu', JSON.stringify(parsedSubMenu));
        }

        let updated = false;
        parsedSubMenu = parsedSubMenu.map(s => {
          if (s.id_mm === '0511' || (s.des_mn && s.des_mn.toLowerCase().includes('barang | obat'))) {
            if (s.lnk !== '/MasterObat') {
              updated = true;
              return { ...s, lnk: '/MasterObat' };
            }
          }
          if (
            s.id_mm === '0309' ||
            s.id_mm === '0513' ||
            (s.lnk && s.lnk.toLowerCase().includes('tarimabarang')) ||
            (s.des_mn && (s.des_mn.toLowerCase().includes('tanda terima') || s.des_mn.toLowerCase().includes('terima barang')))
          ) {
            if (s.lnk !== '/TerimaBarangApotek') {
              updated = true;
              return { ...s, lnk: '/TerimaBarangApotek' };
            }
          }
          return s;
        });
        if (updated) {
          localStorage.setItem('submenu', JSON.stringify(parsedSubMenu));
        }

        // Pastikan menu Surat Pesanan Barang | Obat Apotek juga terdaftar
        const hasSP = parsedSubMenu.some(s => (s.lnk && s.lnk.toLowerCase().includes('pesananapotek')) || (s.des_mn && s.des_mn.toLowerCase().includes('surat pesanan')));
        if (!hasSP) {
          parsedSubMenu.push({
            id_mm: '0512',
            id_mn: '05',
            nama: 'Surat Pesanan Apotek',
            des_mn: 'Surat Pesanan Barang | Obat',
            nm_mm: 'Surat Pesanan Apotek',
            lnk: '/SuratPesananApotek',
            icon: 'bi-file-earmark-text',
            info: 'Surat Pesanan Barang & Obat Apotek'
          });
          localStorage.setItem('submenu', JSON.stringify(parsedSubMenu));
        }

        // Pastikan menu Tanda Terima Barang Apotek juga terdaftar di penunjang medis (03) dan master (05)
        const hasTTB = parsedSubMenu.some(s => s.id_mm === '0309' || (s.lnk && s.lnk.toLowerCase().includes('terimabarangapotek')));
        if (!hasTTB) {
          parsedSubMenu.push({
            id_mm: '0309',
            id_mn: '03',
            nama: 'Tanda Terima Barang Apotek',
            des_mn: 'Tanda Terima Barang Apotek',
            nm_mm: 'Tanda Terima Barang Apotek',
            lnk: '/TerimaBarangApotek',
            icon: 'bi-box-seam',
            info: 'Tanda Terima Barang (TTB) Apotek / Farmasi'
          });
          localStorage.setItem('submenu', JSON.stringify(parsedSubMenu));
        }

        // Pastikan menu Stok Opname Obat juga terdaftar di penunjang medis (03)
        const hasOpname = parsedSubMenu.some(s => s.id_mm === '0310' || (s.lnk && s.lnk.toLowerCase().includes('opnameapotek')));
        if (!hasOpname) {
          parsedSubMenu.push({
            id_mm: '0310',
            id_mn: '03',
            nama: 'Stok Opname Obat',
            des_mn: 'Stok Opname Obat',
            nm_mm: 'Stok Opname Obat',
            lnk: '/OpnameApotek',
            icon: 'bi-clipboard2-check-fill',
            info: 'Stok Opname Fisik Persediaan Obat Apotek / Farmasi'
          });
          localStorage.setItem('submenu', JSON.stringify(parsedSubMenu));
        }

        // Pastikan menu Laporan Narkotika, Psikotropika & Prekursor juga terdaftar di penunjang medis (03)
        const hasLaporanApotek = parsedSubMenu.some(s => s.id_mm === '0311' || (s.lnk && s.lnk.toLowerCase().includes('laporanapotek')));
        if (!hasLaporanApotek) {
          parsedSubMenu.push({
            id_mm: '0311',
            id_mn: '03',
            nama: 'Laporan Apotek',
            des_mn: 'Laporan Narkotika, Psikotropika & Prekursor',
            nm_mm: 'Laporan Apotek (Narkotika & Prekursor)',
            lnk: '/LaporanApotek',
            icon: 'bi-file-earmark-medical-fill',
            info: 'Rekapitulasi & Rincian Penggunaan Narkotika, Psikotropika dan Prekursor Apotek'
          });
          localStorage.setItem('submenu', JSON.stringify(parsedSubMenu));
        }

        // Pastikan menu Aturan Jual Obat terdaftar
        const hasAturanJual = parsedSubMenu.some(s => s.id_mm === '0514' || (s.lnk && s.lnk.toLowerCase().includes('aturanjual')));
        if (!hasAturanJual) {
          parsedSubMenu.push({
            id_mm: '0514',
            id_mn: '05',
            nama: 'Aturan Penjualan Obat',
            des_mn: 'Aturan Penjualan Obat',
            nm_mm: 'Aturan Penjualan Obat Setiap Klasifikasi',
            lnk: '/AturanJual',
            icon: 'bi-sliders',
            info: 'Standar Aturan Harga Jual & Selisih Laba Obat Berdasarkan Klasifikasi Tarif Pasien'
          });
          localStorage.setItem('submenu', JSON.stringify(parsedSubMenu));
        }

        // Pastikan menu Template Billing Group E-Klaim juga terdaftar
        const hasBillingGroup = parsedSubMenu.some(s => (s.lnk && s.lnk.toLowerCase().includes('billinggroup')) || (s.des_mn && s.des_mn.toLowerCase().includes('billing group')));
        if (!hasBillingGroup) {
          parsedSubMenu.push({
            id_mm: '0515',
            id_mn: '05',
            nama: 'Template Billing Group E-Klaim',
            des_mn: 'Template Billing Group E-Klaim',
            nm_mm: 'Template Billing Group E-Klaim',
            lnk: '/BillingGroup',
            icon: 'bi-file-earmark-spreadsheet-fill',
            info: 'Master Mapping 18 Kategori Billing Group E-Klaim Kemenkes RI'
          });
          localStorage.setItem('submenu', JSON.stringify(parsedSubMenu));
        }

        // Pastikan menu Profil Instansi Apotek / Farmasi juga terdaftar
        const hasProfileApotek = parsedSubMenu.some(s => (s.lnk && s.lnk.toLowerCase().includes('profileapotek')) || (s.des_mn && s.des_mn.toLowerCase().includes('profil instansi apotek')));
        if (!hasProfileApotek) {
          parsedSubMenu.push({
            id_mm: '0312',
            id_mn: '03',
            nama: 'Profil Instansi Apotek',
            des_mn: 'Profil Instansi Apotek / Farmasi',
            nm_mm: 'Setting Profil Instansi Apotek / Farmasi',
            lnk: '/ProfileApotek',
            icon: 'bi-hospital-fill',
            info: 'Setting Identitas Faskes, Apoteker Penanggung Jawab & SIK/SIPA Apotek'
          });
          localStorage.setItem('submenu', JSON.stringify(parsedSubMenu));
        }

        // Pastikan menu Laporan Penjualan Gudang Apotek (Finance) terdaftar
        const hasLapFinance = parsedSubMenu.some(s => (s.lnk && s.lnk.toLowerCase().includes('lapapotekfinance')) || (s.des_mn && s.des_mn.toLowerCase().includes('laporan keuangan apotek')));
        if (!hasLapFinance) {
          parsedSubMenu.push({
            id_mm: '0313',
            id_mn: '03',
            nama: 'Lap. Keuangan Apotek',
            des_mn: 'Laporan Penjualan Gudang Apotek',
            nm_mm: 'Laporan Keuangan & Penjualan Gudang Apotek',
            lnk: '/LapApotekFinance',
            icon: 'bi-grid-3x3-gap-fill',
            info: 'Laporan Penjualan & Retur serta Pembelian & Retur Gudang Apotek'
          });
          localStorage.setItem('submenu', JSON.stringify(parsedSubMenu));
        }

        setAllSubMenus(parsedSubMenu);
      } catch (err) {
        console.error('Error parsing submenu:', err);
      }
    }

    const updateTime = () => {
      const now = new Date();
      const options = { weekday: 'long', year: 'numeric', month: 'long', day: 'numeric' };
      setTime({
        date: now.toLocaleDateString('id-ID', options),
        clock: now.toLocaleTimeString('id-ID') + ' WIB'
      });
    };

    // Helper Tanggal Hari Ini DD/MM/YYYY
    const getTodayDdmmyyyy = () => {
      const now = new Date();
      const dd = String(now.getDate()).padStart(2, '0');
      const mm = String(now.getMonth() + 1).padStart(2, '0');
      const yyyy = now.getFullYear();
      return `${dd}/${mm}/${yyyy}`;
    };

    // Fetch Total Pasien RJ dari /show_pasienrj (periode & periode2 hari ini)
    const fetchPasienRjCount = async () => {
      const getApiUrl = () => localStorage.getItem('api_url') || 'http://202.155.94.169:8080';
      const apiUrl = getApiUrl();
      const todayStr = getTodayDdmmyyyy();

      try {
        let res;
        try {
          res = await fetch(`${apiUrl}/show_pasienrj`, {
            method: 'POST',
            headers: { 'Content-Type': 'application/json' },
            body: JSON.stringify({ periode: todayStr, periode2: todayStr })
          });
        } catch {
          res = await fetch(`${apiUrl}/show_pasienrj?periode=${encodeURIComponent(todayStr)}&periode2=${encodeURIComponent(todayStr)}`, {
            method: 'GET',
            headers: { 'Content-Type': 'application/json' }
          });
        }

        if (res.ok) {
          const json = await res.json();
          if (json?.list_pasienrj && Array.isArray(json.list_pasienrj)) {
            setRawatJalanCount(json.list_pasienrj.length);
          } else if (Array.isArray(json)) {
            setRawatJalanCount(json.length);
          }
        }
      } catch (err) {
        console.warn('Gagal fetch /show_pasienrj di Home:', err);
      }
    };

    updateTime();
    fetchPasienRjCount();
    const interval = setInterval(updateTime, 1000);
    return () => clearInterval(interval);
  }, []);



  const getSubMenuIcon = (name) => {
    if (!name) return 'bi-card-list';
    const n = name.toUpperCase();
    if (n.includes('OPNAME')) return 'bi-clipboard2-check-fill';
    if (n.includes('PENJUALAN') || n.includes('TRANSAKSI OBAT') || n.includes('APOTEK')) return 'bi-capsule-pill';
    if (n.includes('MASTER') || n.includes('BARANG') || n.includes('OBAT')) return 'bi-folder2-open';
    if (n.includes('GUDANG') || n.includes('STOK') || n.includes('TTB') || n.includes('TANDA TERIMA')) return 'bi-box-seam';
    if (n.includes('USER') || n.includes('PENGGUNA') || n.includes('AKUN')) return 'bi-people-fill';
    if (n.includes('SETTING') || n.includes('PENGATURAN') || n.includes('KONFIGURASI')) return 'bi-sliders';
    if (n.includes('LAPORAN') || n.includes('REPORT')) return 'bi-file-earmark-bar-graph';
    if (n.includes('KEUANGAN') || n.includes('FAKTUR') || n.includes('INVOICE') || n.includes('FINANCE')) return 'bi-wallet2';
    if (n.includes('KASIR') || n.includes('PEMBAYARAN')) return 'bi-cash-coin';
    if (n.includes('PASIEN') || n.includes('RAWAT') || n.includes('PENUNJANG MEDIS'))  return 'bi-heart-pulse';
    return 'bi-journal-bookmark-fill';
  };

  const getMenuIcon = (menuName) => {
    if (!menuName) return 'bi-grid-1x2';
    const n = menuName.toUpperCase();
    if (n.includes('MASTER') || n.includes('DATA')) return 'bi-database-fill';
    if (n.includes('GUDANG') || n.includes('LOGISTIK') || n.includes('STOK')) return 'bi-box-seam';
    if (n.includes('ADM GUDANG')) return 'bi-building-gear';
    if (n.includes('APOTEKER') || n.includes('FARMASI') || n.includes('OBAT')) return 'bi-capsule';
    if (n.includes('ADMINISTRATOR') || n.includes('USER') || n.includes('PENGGUNA') || n.includes('ADMIN')) return 'bi-shield-lock-fill';
    if (n.includes('SETTING') || n.includes('PENGATURAN')) return 'bi-gear-fill';
    if (n.includes('KEUANGAN') || n.includes('FINANCE') || n.includes('BILLING') || n.includes('PENAGIHAN') || n.includes('AKUNTANSI')) return 'bi-wallet2';
    if (n.includes('KASIR')) return 'bi-cash-coin';
    if (n.includes('LAPORAN') || n.includes('REPORT')) return 'bi-file-earmark-bar-graph';
    if (n.includes('PENDAFTARAN') || n.includes('REGISTRASI') || n.includes('PASIEN BARU')) return 'bi-person-plus-fill';
    if (n.includes('RAWAT INAP')) return 'bi-hospital';
    if (n.includes('RAWAT JALAN') || n.includes('POLI') || n.includes('RAWAT')) return 'bi-heart-pulse-fill';
    if (n.includes('IGD') || n.includes('EMERGENCY')) return 'bi-lightning-charge-fill';
    return 'bi-grid-1x2';
  };

  const handleLogout = () => {
    localStorage.clear();
    navigate('/');
  };

  return (
    <div style={styles.appContainer}>
      {/* ══════════════ 1. TOP NAVBAR ══════════════ */}
      <nav className="navbar navbar-expand-xl navbar-dark shadow-sm" style={styles.navbarCustom}>
        <Container fluid>
          <a
            className="navbar-brand d-flex align-items-center me-3"
            href="#home"
            onClick={(e) => {
              e.preventDefault();
              setActiveMenu('');
            }}
            style={{ cursor: 'pointer', textDecoration: 'none' }}
          >
            <div className="d-flex align-items-center justify-content-center me-2 rounded-3 p-1"
              style={{ background: 'rgba(255, 255, 255, 0.1)', border: '1px solid rgba(255, 255, 255, 0.15)' }}>
              <i className="bi bi-hospital text-warning fs-5"></i>
            </div>
            <div>
              <div className="d-flex align-items-center gap-2">
                <div className="fw-bold text-white lh-1" style={{ fontSize: '0.95rem', letterSpacing: '0.3px' }}>
                  SIMRS2 <span style={{ color: '#2dd4bf', fontWeight: 500, fontSize: '0.8rem' }}>Finance</span>
                </div>
                <span
                  role="button"
                  onClick={(e) => {
                    e.stopPropagation();
                    setShowVersionModal(true);
                  }}
                  className="badge rounded-pill shadow-xs"
                  style={{
                    background: 'rgba(45, 212, 191, 0.18)',
                    color: '#2dd4bf',
                    border: '1px solid rgba(45, 212, 191, 0.35)',
                    fontSize: '0.64rem',
                    padding: '2px 7px',
                    fontWeight: 700,
                    cursor: 'pointer'
                  }}
                  title="Klik untuk melihat Detail Versi & Catatan Rilis"
                >
                  v{APP_VERSION.version}
                </span>
              </div>
              <div className="text-white-50 small" style={{ fontSize: '0.65rem' }}>Sistem Informasi Management Rumah Sakit</div>
            </div>
          </a>

          <button 
            className="navbar-toggler" 
            type="button" 
            onClick={() => setIsNavOpen(!isNavOpen)}
            style={{ border: 'none', outline: 'none' }}
          >
            <span className="navbar-toggler-icon"></span>
          </button>

          <div className={`collapse navbar-collapse ${isNavOpen ? 'show' : ''}`} id="navbarNav">
            <ul className="navbar-nav me-auto mb-2 mb-lg-0 flex-row flex-wrap gap-1 mt-2 mt-xl-0">
              {menus.map((item) => {
                const isActive = activeMenu === item.id_mn;

                return (
                  <li className="nav-item" key={item.id_mn}>
                    <a
                      className={`nav-link-custom ${isActive ? 'active' : ''}`}
                      href={`#${item.des_mn.toLowerCase().replace(/\s+/g, '-')}`}
                      onClick={(e) => {
                        e.preventDefault();
                        if (item.lnk) {
                          const trimmedLnk = item.lnk.trim();
                          const path = trimmedLnk.startsWith('/') ? trimmedLnk : `/${trimmedLnk}`;
                          navigate(path);
                        } else {
                          setActiveMenu(item.id_mn);
                        }
                        setIsNavOpen(false);
                      }}
                      style={{
                        ...styles.navLinkCustom,
                        ...(isActive ? styles.navLinkActive : {})
                      }}
                    >
                      <i className={`bi ${getMenuIcon(item.des_mn)} me-1`}></i>
                      {item.des_mn.toLowerCase().replace(/\b\w/g, s => s.toUpperCase())}
                    </a>
                  </li>
                );
              })}
            </ul>

            <div className="d-flex align-items-center text-white text-end gap-3 ms-auto">
              <div className="small border-end pe-3 border-light border-opacity-25 d-none d-sm-block">
                <div className="fw-semibold text-white-50" style={{ fontSize: '0.75rem' }}>{time.date}</div>
                <div className="fw-bold" style={{ fontSize: '0.8rem', color: '#5eead4' }}>{time.clock}</div>
              </div>

              <Dropdown align="end">
                <Dropdown.Toggle
                  as="div"
                  role="button"
                  className="d-flex align-items-center gap-2 px-2 py-1 rounded-3 custom-profile-toggle"
                  style={{ cursor: 'pointer', transition: 'all 0.2s ease', background: 'rgba(255,255,255,0.08)', border: '1px solid rgba(255,255,255,0.12)' }}
                >
                  <div
                    className="d-flex align-items-center justify-content-center fw-bold rounded-circle shadow-sm"
                    style={{ width: '34px', height: '34px', fontSize: '0.85rem', background: 'linear-gradient(135deg, #f59e0b, #d97706)', color: '#ffffff' }}
                  >
                    {username ? username.charAt(0).toUpperCase() : 'A'}
                  </div>

                  <div className="d-none d-md-block text-start">
                    <div className="text-white fw-semibold lh-1" style={{ fontSize: '0.82rem' }}>{username}</div>
                    <div className="mt-1 d-flex align-items-center gap-1" style={{ fontSize: '0.68rem', color: '#5eead4' }}>
                      <span className="rounded-circle bg-success d-inline-block" style={{ width: '6px', height: '6px' }}></span>
                      <span>Online</span>
                    </div>
                  </div>
                  <i className="bi bi-chevron-down text-white-50 ms-1 small"></i>
                </Dropdown.Toggle>

                <Dropdown.Menu className="shadow-lg border-0 mt-2 py-2 style-dropdown-menu" style={{ minWidth: '200px', borderRadius: '12px' }}>
                  <div className="px-3 py-2 border-bottom mb-1 bg-light rounded-top">
                    <p className="text-muted small mb-0" style={{ fontSize: '0.7rem' }}>Pengguna Aktif</p>
                    <p className="fw-bold text-dark mb-0" style={{ fontSize: '0.85rem' }}>{username}</p>
                  </div>

                  <Dropdown.Item onClick={() => setShowGlobalIpModal(true)} className="py-2 text-dark small d-flex align-items-center gap-2 fw-semibold">
                    <i className="bi bi-hdd-network-fill text-warning fs-6"></i> Pengaturan IP Server
                  </Dropdown.Item>

                  <Dropdown.Item onClick={handleLogout} className="py-2 text-danger small d-flex align-items-center gap-2 fw-semibold">
                    <i className="bi bi-box-arrow-right fs-6"></i> Keluar Aplikasi
                  </Dropdown.Item>
                </Dropdown.Menu>
              </Dropdown>
            </div>
          </div>
        </Container>

        <GlobalIpModal
          show={showGlobalIpModal}
          onHide={() => setShowGlobalIpModal(false)}
        />
      </nav>

      {/* ══════════════ 2. MAIN CONTENT AREA ══════════════ */}
      <div style={styles.mainContent}>
        {!activeMenu ? (
          /* TAMPILAN LANDING PAGE — MINIMALIS PUTIH MODERN */
          <div className="flex-grow-1 d-flex flex-column justify-content-center overflow-hidden mb-2" style={{ minHeight: 0 }}>
            <div
              className="w-100 h-100 d-flex flex-column align-items-center justify-content-center"
              style={{
                borderRadius: '16px',
                position: 'relative',
                background: 'linear-gradient(145deg, #ffffff 0%, #f0f9ff 50%, #f0fdf4 100%)',
                border: '1px solid #e2e8f0',
                boxShadow: '0 4px 24px rgba(13, 148, 136, 0.06)',
                overflow: 'hidden',
                minHeight: 0,
              }}
            >
              {/* Dekorasi lingkaran blur di sudut */}
              <div style={{ position: 'absolute', width: '350px', height: '350px', borderRadius: '50%', background: 'radial-gradient(circle, rgba(13,148,136,0.07) 0%, transparent 70%)', top: '-80px', right: '-80px', pointerEvents: 'none' }} />
              <div style={{ position: 'absolute', width: '300px', height: '300px', borderRadius: '50%', background: 'radial-gradient(circle, rgba(2,132,199,0.06) 0%, transparent 70%)', bottom: '-60px', left: '-60px', pointerEvents: 'none' }} />

              {/* Logo */}
              <img src="/logo.png" alt="SIMRS2" style={{ width: '100px', height: 'auto', marginBottom: '1rem', filter: 'drop-shadow(0 4px 12px rgba(13,148,136,0.2))' }} />

              {/* Judul */}
              <h4 style={{ fontSize: '1.1rem', fontWeight: '700', color: '#0f172a', margin: 0, letterSpacing: '0.3px' }}>
                Sistem Informasi Management Rumah Sakit
              </h4>
              <p style={{ fontSize: '0.82rem', color: '#0d9488', fontWeight: '600', margin: '0.3rem 0 1.5rem', letterSpacing: '0.5px' }}>
                ( Finance | Management Keuangan )
              </p>

              {/* Divider */}
              <div style={{ width: '60px', height: '3px', borderRadius: '2px', background: 'linear-gradient(90deg, #0d9488, #0284c7)', marginBottom: '1.5rem' }} />

              {/* Badge selamat datang */}
              <div style={{ fontSize: '0.78rem', color: '#475569', marginBottom: '0.6rem', display: 'flex', alignItems: 'center', gap: '6px' }}>
                <i className="bi bi-stars text-warning"></i>
                <span>Selamat datang, <strong style={{ color: '#0f172a' }}>{username}</strong></span>
              </div>

              {/* Badge Versi Aplikasi & Rilis */}
              <div
                role="button"
                onClick={() => setShowVersionModal(true)}
                className="badge rounded-pill d-inline-flex align-items-center gap-2 px-3 py-1.5 mb-3 shadow-sm"
                style={{
                  background: 'linear-gradient(135deg, #e0f2fe 0%, #f0fdf4 100%)',
                  color: '#0369a1',
                  border: '1px solid #bae6fd',
                  fontSize: '0.73rem',
                  cursor: 'pointer',
                  transition: 'all 0.2s ease',
                  fontWeight: 600
                }}
                title="Klik untuk melihat catatan rilis & detail pembaruan"
                onMouseEnter={e => { e.currentTarget.style.transform = 'translateY(-1px)'; e.currentTarget.style.borderColor = '#0284c7'; }}
                onMouseLeave={e => { e.currentTarget.style.transform = 'translateY(0)'; e.currentTarget.style.borderColor = '#bae6fd'; }}
              >
                <i className="bi bi-patch-check-fill text-primary" />
                <span style={{ color: '#0f172a', fontWeight: 800 }}>SIMRS2 v{APP_VERSION.version}</span>
                <span className="text-muted" style={{ fontSize: '0.68rem' }}>&bull; Rilis {APP_VERSION.releaseDate}</span>
                <span className="badge rounded-pill text-white ms-1" style={{ background: '#0d9488', fontSize: '0.62rem', padding: '2px 6px' }}>
                  Changelog <i className="bi bi-arrow-up-right ms-0.5" />
                </span>
              </div>

              {/* STATISTIK RINGKAS: JUMLAH PASIEN & TEMPAT RAWAT */}
              <div className="d-flex align-items-center justify-content-center gap-3 mb-3 flex-wrap px-3" style={{ maxWidth: '850px', width: '100%' }}>
                {/* Stat 1: Pasien */}
                <div
                  onClick={() => setShowPatientModal(true)}
                  style={{
                    flex: '1 1 240px',
                    background: 'linear-gradient(135deg, #ffffff 0%, #f0f9ff 100%)',
                    border: '1.5px solid #bae6fd',
                    borderRadius: '12px',
                    padding: '0.75rem 1rem',
                    cursor: 'pointer',
                    transition: 'all 0.2s ease',
                    boxShadow: '0 4px 12px rgba(2, 132, 199, 0.06)',
                    display: 'flex',
                    alignItems: 'center',
                    justifyContent: 'space-between',
                  }}
                  onMouseEnter={e => { e.currentTarget.style.transform = 'translateY(-2px)'; e.currentTarget.style.borderColor = '#0284c7'; }}
                  onMouseLeave={e => { e.currentTarget.style.transform = 'translateY(0)'; e.currentTarget.style.borderColor = '#bae6fd'; }}
                >
                  <div>
                    <div style={{ fontSize: '0.7rem', fontWeight: '600', color: '#0369a1', textTransform: 'uppercase', letterSpacing: '0.5px' }}>
                      <i className="bi bi-people-fill me-1"></i> Jumlah Pasien Aktif
                    </div>
                    <div style={{ fontSize: '1.4rem', fontWeight: '800', color: '#0f172a', lineHeight: 1.2 }}>
                      {patientStats.total} <span style={{ fontSize: '0.75rem', fontWeight: '600', color: '#64748b' }}>Pasien</span>
                    </div>
                    <div style={{ fontSize: '0.68rem', color: '#0284c7', fontWeight: '500', marginTop: '2px' }}>
                      Rawat Inap: <strong>{patientStats.rawatInap}</strong> | Rawat Jalan: <strong>{patientStats.rawatJalan}</strong>
                    </div>
                  </div>
                  <div style={{ width: '42px', height: '42px', borderRadius: '10px', background: 'rgba(2, 132, 199, 0.1)', display: 'flex', alignItems: 'center', justifyCenter: 'center', color: '#0284c7', fontSize: '1.3rem' }} className="justify-content-center">
                    <i className="bi bi-heart-pulse-fill"></i>
                  </div>
                </div>

                {/* Stat 2: Tempat Rawat Tersedia */}
                <div
                  onClick={() => setShowBedModal(true)}
                  style={{
                    flex: '1 1 240px',
                    background: 'linear-gradient(135deg, #ffffff 0%, #f0fdf4 100%)',
                    border: '1.5px solid #bbf7d0',
                    borderRadius: '12px',
                    padding: '0.75rem 1rem',
                    cursor: 'pointer',
                    transition: 'all 0.2s ease',
                    boxShadow: '0 4px 12px rgba(13, 148, 136, 0.06)',
                    display: 'flex',
                    alignItems: 'center',
                    justifyContent: 'space-between',
                  }}
                  onMouseEnter={e => { e.currentTarget.style.transform = 'translateY(-2px)'; e.currentTarget.style.borderColor = '#0d9488'; }}
                  onMouseLeave={e => { e.currentTarget.style.transform = 'translateY(0)'; e.currentTarget.style.borderColor = '#bbf7d0'; }}
                >
                  <div>
                    <div style={{ fontSize: '0.7rem', fontWeight: '600', color: '#0f766e', textTransform: 'uppercase', letterSpacing: '0.5px' }}>
                      <i className="bi bi-door-open-fill me-1"></i> Tempat Rawat Tersedia
                    </div>
                    <div style={{ fontSize: '1.4rem', fontWeight: '800', color: '#0f172a', lineHeight: 1.2 }}>
                      {bedStats.available} <span style={{ fontSize: '0.75rem', fontWeight: '600', color: '#64748b' }}>Bed Kosong</span>
                    </div>
                    <div style={{ fontSize: '0.68rem', color: '#0d9488', fontWeight: '500', marginTop: '2px' }}>
                      Kapasitas Total: <strong>{bedStats.total} Bed</strong> ({((bedStats.filled / bedStats.total) * 100).toFixed(1)}% Terisi)
                    </div>
                  </div>
                  <div style={{ width: '42px', height: '42px', borderRadius: '10px', background: 'rgba(13, 148, 136, 0.1)', display: 'flex', alignItems: 'center', justifyCenter: 'center', color: '#0d9488', fontSize: '1.3rem' }} className="justify-content-center">
                    <i className="bi bi-hospital-fill"></i>
                  </div>
                </div>
              </div>

              {/* Tombol menu */}
              <div className="d-flex align-items-center gap-2 flex-wrap justify-content-center">
                <span style={{ fontSize: '0.73rem', color: '#94a3b8', marginRight: '4px' }}>
                  <i className="bi bi-hand-index-thumb-fill me-1"></i>Pilih menu:
                </span>
                {menus.map((m) => (
                  <button
                    key={m.id_mn}
                    onClick={() => {
                      if (m.lnk) {
                        const trimmedLnk = m.lnk.trim();
                        const path = trimmedLnk.startsWith('/') ? trimmedLnk : `/${trimmedLnk}`;
                        navigate(path);
                      } else {
                        setActiveMenu(m.id_mn);
                      }
                    }}
                    style={{
                      background: 'white',
                      border: '1.5px solid #e2e8f0',
                      borderRadius: '8px',
                      padding: '0.35rem 0.85rem',
                      fontSize: '0.75rem',
                      fontWeight: '600',
                      color: '#334155',
                      cursor: 'pointer',
                      transition: 'all 0.2s ease',
                      boxShadow: '0 2px 6px rgba(0,0,0,0.04)',
                      display: 'flex',
                      alignItems: 'center',
                      gap: '5px',
                    }}
                    onMouseEnter={e => { e.currentTarget.style.background = '#0d9488'; e.currentTarget.style.color = '#fff'; e.currentTarget.style.borderColor = '#0d9488'; }}
                    onMouseLeave={e => { e.currentTarget.style.background = 'white'; e.currentTarget.style.color = '#334155'; e.currentTarget.style.borderColor = '#e2e8f0'; }}
                  >
                    <i className={`bi ${getMenuIcon(m.des_mn)}`}></i>
                    {m.des_mn}
                  </button>
                ))}
              </div>
            </div>
          </div>
        ) : (
          /* TAMPILAN SUB-MENU */
          <div className="w-100 mb-auto">
            <Row className="g-3 align-items-start mb-3">
              <Col xl={8} lg={7} md={12}>
                <Card style={styles.mainCard} className="shadow-sm border-0">
                  <div style={{ ...styles.cardHeader, ...styles.bgMenuHeader }} className="d-flex justify-content-between align-items-center">
                    <div className="d-flex align-items-center gap-2">
                      <i className="bi bi-grid-fill text-warning"></i>
                      <span>SUB MENU — {menus.find(m => m.id_mn === activeMenu)?.des_mn || 'MENU'}</span>
                    </div>
                    <span className="badge rounded-pill bg-light text-dark fw-semibold px-2 py-1" style={{ fontSize: '0.7rem' }}>
                      {allSubMenus.filter(sub => sub.id_mn === activeMenu).length} Fitur
                    </span>
                  </div>

                  <Card.Body style={styles.cardBody}>
                    <Row className="row-cols-1 row-cols-sm-2 row-cols-md-4 g-2">
                      {allSubMenus
                        .filter((sub) => sub.id_mn === activeMenu)
                        .map((sub, index) => {
                          const menuLabel = sub.des_mn || sub.nama || sub.nm_mm || 'Menu';
                          const menuInfo  = sub.info || '';
                          let menuLnk = '#';
                          if (sub.lnk) {
                            const trimmed = sub.lnk.trim();
                            menuLnk = trimmed.startsWith('/') ? trimmed : `/${trimmed}`;
                          }

                          // Pastikan Master Obat & Barang selalu mengarah ke /MasterObat
                          const labelLower = (menuLabel || '').toLowerCase();
                          if (
                            sub.id_mm === '0511' ||
                            labelLower.includes('master obat') ||
                            labelLower.includes('barang | obat') ||
                            labelLower.includes('master barang') ||
                            menuLnk.toLowerCase() === '/masterobat' ||
                            menuLnk.toLowerCase() === '/formobat'
                          ) {
                            menuLnk = '/MasterObat';
                          } else if (
                            labelLower.includes('transaksi obat') ||
                            labelLower.includes('penjualan obat') ||
                            labelLower.includes('trs apotek') ||
                            labelLower.includes('transaksi apotek') ||
                            menuLnk.toLowerCase() === '/trsapotek' ||
                            menuLnk.toLowerCase() === '/transaksiobat'
                          ) {
                            menuLnk = '/TrsApotek';
                          } else if (
                            sub.id_mm === '0309' ||
                            sub.id_mm === '0513' ||
                            labelLower.includes('tanda terima') ||
                            labelLower.includes('terima barang') ||
                            labelLower.includes('tarima barang') ||
                            menuLnk.toLowerCase().includes('terimabarang') ||
                            menuLnk.toLowerCase().includes('tarimabarang') ||
                            menuLnk.toLowerCase() === '/ttb'
                          ) {
                            menuLnk = '/TerimaBarangApotek';
                          } else if (
                            sub.id_mm === '0310' ||
                            labelLower.includes('stok opname') ||
                            labelLower.includes('opname obat') ||
                            labelLower.includes('opname apotek') ||
                            menuLnk.toLowerCase().includes('opname')
                          ) {
                            menuLnk = '/OpnameApotek';
                          } else if (
                            sub.id_mm === '0311' ||
                            labelLower.includes('laporan apotek') ||
                            labelLower.includes('laporan narkotika') ||
                            labelLower.includes('narkotika') ||
                            labelLower.includes('psikotropika') ||
                            labelLower.includes('prekursor') ||
                            menuLnk.toLowerCase().includes('laporanapotek')
                          ) {
                            menuLnk = '/LaporanApotek';
                          } else if (menuLnk === '/') {
                            menuLnk = '#';
                          }
                          const subKey    = sub.id_mm || `${sub.id_mn}_${index}`;
                          const isHovered = hoveredSubmenu === subKey;

                          return (
                            <Col key={subKey}>
                              <Link
                                to={menuLnk}
                                state={{ info: menuInfo, nama: menuLabel }}
                                style={{
                                  ...styles.btnGradientBox,
                                  background: isHovered
                                    ? 'linear-gradient(135deg, #0d9488 0%, #0f766e 100%)'
                                    : 'linear-gradient(135deg, #ffffff 0%, #f8fafc 100%)',
                                  color: isHovered ? '#ffffff' : '#1e293b',
                                  borderColor: isHovered ? '#0d9488' : '#cbd5e1',
                                  transform: isHovered ? 'translateY(-4px)' : 'translateY(0)',
                                  boxShadow: isHovered
                                    ? '0 10px 22px rgba(13, 148, 136, 0.32)'
                                    : '0 3px 10px rgba(15, 23, 42, 0.05)',
                                }}
                                onMouseEnter={() => {
                                  setHoveredSubmenu(subKey);
                                  setHoveredInfo({ nama: menuLabel, info: menuInfo });
                                }}
                                onMouseLeave={() => {
                                  setHoveredSubmenu(null);
                                  setHoveredInfo(null);
                                }}
                              >
                                <i
                                  className={`bi ${getSubMenuIcon(menuLabel)}`}
                                  style={{
                                    fontSize: '1.65rem',
                                    marginBottom: '0.35rem',
                                    color: isHovered ? '#fde047' : '#0d9488',
                                    transition: 'color 0.25s ease'
                                  }}
                                ></i>
                                <span style={{ fontWeight: 700, fontSize: '0.83rem', lineHeight: 1.3 }}>
                                  {menuLabel.toLowerCase().replace(/\b\w/g, s => s.toUpperCase())}
                                </span>
                              </Link>
                            </Col>
                          );
                        })}

                      {allSubMenus.filter((sub) => sub.id_mn === activeMenu).length === 0 && (
                        <Col xs={12} className="text-center text-muted my-3 small py-4">
                          <i className="bi bi-folder-x fs-3 d-block mb-1 opacity-50"></i>
                          Tidak ada sub-menu untuk kategori menu ini.
                        </Col>
                      )}
                    </Row>
                  </Card.Body>
                </Card>
              </Col>

              <Col xl={4} lg={5} md={12}>
                <Card style={styles.mainCard} className="shadow-sm border-0">
                  <div style={{ ...styles.cardHeader, ...styles.bgInfoHeader }}>
                    <i className="bi bi-info-circle-fill me-2 text-warning"></i> Informasi Fitur
                  </div>
                  <Card.Body style={{ ...styles.cardBody, padding: '0.85rem' }}>
                    {hoveredInfo ? (
                      <div style={{
                        background: 'linear-gradient(135deg, #f0fdf4, #dcfce7)',
                        border: '1px solid #86efac',
                        borderLeft: '4px solid #0d9488',
                        borderRadius: '10px',
                        padding: '0.9rem',
                        transition: 'all 0.2s ease',
                        boxShadow: '0 4px 12px rgba(13, 148, 136, 0.08)'
                      }}>
                        <div className="fw-bold mb-1 d-flex align-items-center gap-1" style={{ fontSize: '0.84rem', color: '#0f766e' }}>
                          <i className="bi bi-bookmark-fill text-teal"></i>
                          {hoveredInfo.nama}
                        </div>
                        <div style={{ fontSize: '0.78rem', color: '#374151', lineHeight: 1.6 }}>
                          {hoveredInfo.info || <span className="text-muted fst-italic">Tidak ada deskripsi</span>}
                        </div>
                      </div>
                    ) : (
                      <div style={{ maxHeight: '220px', overflowY: 'auto' }}>
                        {allSubMenus
                          .filter(sub => sub.id_mn === activeMenu)
                          .filter(sub => sub.info)
                          .map((sub, i) => (
                            <div key={i} style={{
                              ...styles.infoBox,
                              marginBottom: '0.55rem',
                              padding: '0.65rem 0.85rem',
                            }} className="shadow-sm">
                              <div className="fw-bold mb-1" style={{ fontSize: '0.76rem', color: '#0f766e' }}>
                                <i className="bi bi-chevron-right me-1 text-teal"></i>
                                {sub.des_mn || sub.nama || sub.nm_mm}
                              </div>
                              <div style={{ fontSize: '0.73rem', color: '#475569', lineHeight: 1.5 }}>
                                {sub.info}
                              </div>
                            </div>
                          ))}
                        {allSubMenus
                          .filter(sub => sub.id_mn === activeMenu)
                          .every(sub => !sub.info) && (
                          <div style={styles.infoBox} className="shadow-sm w-100">
                            <i className="bi bi-bell-fill text-warning me-2"></i> Pilih menu yang akan dijalankan
                          </div>
                        )}
                      </div>
                    )}
                  </Card.Body>
                </Card>
              </Col>
            </Row>
          </div>
        )}

        {/* ══════════════ FOOTER WIDGETS STATIS ══════════════ */}
        <Row className="g-3 flex-shrink-0 mt-auto">
          <Col lg={3} md={6} sm={12}>
            <div
              style={{ ...styles.summaryCard, background: 'linear-gradient(135deg, #0284c7 0%, #0369a1 100%)', cursor: 'pointer' }}
              className="shadow-sm"
              onClick={() => setShowPatientModal(true)}
            >
              <div>
                <div style={styles.sumValue}>{patientStats.total} Pasien</div>
                <div style={styles.sumLabel}>Pasien Aktif (Rawat Inap: {patientStats.rawatInap})</div>
              </div>
              <div style={styles.iconWrap}><i className="bi bi-people-fill"></i></div>
            </div>
          </Col>

          <Col lg={3} md={6} sm={12}>
            <div
              style={{ ...styles.summaryCard, background: 'linear-gradient(135deg, #0d9488 0%, #0f766e 100%)', cursor: 'pointer' }}
              className="shadow-sm"
              onClick={() => setShowBedModal(true)}
            >
              <div>
                <div style={styles.sumValue}>{bedStats.available} Bed Tersedia</div>
                <div style={styles.sumLabel}>Dari Total {bedStats.total} Bed Rawat Inap</div>
              </div>
              <div style={styles.iconWrap}><i className="bi bi-door-open-fill"></i></div>
            </div>
          </Col>

          <Col lg={3} md={6} sm={12}>
            <div style={{ ...styles.summaryCard, background: 'linear-gradient(135deg, #8b5cf6 0%, #6d28d9 100%)' }} className="shadow-sm">
              <div>
                <div style={styles.sumValue}>{((bedStats.filled / bedStats.total) * 100).toFixed(1)}% BOR</div>
                <div style={styles.sumLabel}>Bed Occupancy Rate</div>
              </div>
              <div style={styles.iconWrap}><i className="bi bi-activity"></i></div>
            </div>
          </Col>

          <Col lg={3} md={6} sm={12}>
            <div style={{ ...styles.summaryCard, ...styles.sum3 }} className="shadow-sm">
              <div>
                <div style={styles.sumValue}>RS Mary</div>
                <div style={styles.sumLabel}>Cileungsi Hijau (SIMRS2)</div>
              </div>
              <div style={styles.iconWrap}><i className="bi bi-hospital-fill"></i></div>
            </div>
          </Col>
        </Row>

        {/* ══════════════ MODAL DETAIL TEMPAT RAWAT ══════════════ */}
        <Modal show={showBedModal} onHide={() => setShowBedModal(false)} centered size="lg">
          <Modal.Header closeButton style={{ background: 'linear-gradient(135deg, #0f172a 0%, #0d9488 100%)', color: '#fff' }}>
            <Modal.Title style={{ fontSize: '0.95rem', fontWeight: '700' }} className="d-flex align-items-center gap-2">
              <i className="bi bi-door-open-fill text-warning fs-5"></i>
              <span>DETAIL KETERSEDIAAN TEMPAT RAWAT INAP</span>
            </Modal.Title>
          </Modal.Header>

          <Modal.Body style={{ background: '#f8fafc', padding: '1.25rem' }}>
            <div className="d-flex align-items-center justify-content-between p-3 mb-3 rounded-3" style={{ background: '#e0f2fe', border: '1px solid #bae6fd' }}>
              <div>
                <div className="fw-bold text-dark" style={{ fontSize: '0.9rem' }}>Status Tempat Tidur Rumah Sakit</div>
                <div className="small text-muted" style={{ fontSize: '0.75rem' }}>Total Kapasitas: <strong>{bedStats.total} Bed</strong> | Terisi: <strong>{bedStats.filled} Bed</strong></div>
              </div>
              <span className="badge rounded-pill bg-teal px-3 py-2" style={{ background: '#0d9488', fontSize: '0.85rem' }}>
                {bedStats.available} Bed Tersedia
              </span>
            </div>

            <Row className="g-3">
              {bedStats.classes.map((cls, idx) => {
                const percent = Math.round((cls.filled / cls.total) * 100);
                return (
                  <Col md={6} key={idx}>
                    <div className="p-3 bg-white rounded-3 border shadow-sm h-100">
                      <div className="d-flex justify-content-between align-items-center mb-1">
                        <span className="fw-bold text-dark" style={{ fontSize: '0.88rem' }}>{cls.class}</span>
                        <span className="badge rounded-pill bg-success-subtle text-success border border-success-subtle px-2.5 py-1" style={{ fontSize: '0.72rem' }}>
                          {cls.available} Bed Kosong
                        </span>
                      </div>
                      <div className="small text-muted mb-2" style={{ fontSize: '0.75rem' }}>
                        Terisi: {cls.filled} / {cls.total} Bed ({percent}%)
                      </div>
                      <ProgressBar
                        now={percent}
                        variant={percent > 85 ? "danger" : percent > 70 ? "warning" : "info"}
                        style={{ height: '8px', borderRadius: '4px' }}
                      />
                    </div>
                  </Col>
                );
              })}
            </Row>
          </Modal.Body>

          <Modal.Footer style={{ background: '#f1f5f9' }}>
            <Button variant="secondary" size="sm" onClick={() => setShowBedModal(false)}>
              Tutup
            </Button>
          </Modal.Footer>
        </Modal>

        {/* ══════════════ MODAL DETAIL PASIEN ══════════════ */}
        <Modal show={showPatientModal} onHide={() => setShowPatientModal(false)} centered size="lg">
          <Modal.Header closeButton style={{ background: 'linear-gradient(135deg, #0f172a 0%, #0284c7 100%)', color: '#fff' }}>
            <Modal.Title style={{ fontSize: '0.95rem', fontWeight: '700' }} className="d-flex align-items-center gap-2">
              <i className="bi bi-people-fill text-warning fs-5"></i>
              <span>DETAIL INFORMASI PASIEN AKTIF</span>
            </Modal.Title>
          </Modal.Header>

          <Modal.Body style={{ background: '#f8fafc', padding: '1.25rem' }}>
            <Row className="g-3 mb-3">
              <Col md={4}>
                <div className="p-3 bg-white rounded-3 border text-center shadow-sm">
                  <div className="text-muted small" style={{ fontSize: '0.73rem' }}>Total Pasien Aktif</div>
                  <div className="fw-bold text-dark fs-3">{patientStats.total}</div>
                </div>
              </Col>
              <Col md={4}>
                <div className="p-3 bg-white rounded-3 border text-center shadow-sm">
                  <div className="text-muted small" style={{ fontSize: '0.73rem' }}>Pasien Rawat Inap</div>
                  <div className="fw-bold text-teal fs-3" style={{ color: '#0d9488' }}>{patientStats.rawatInap}</div>
                </div>
              </Col>
              <Col md={4}>
                <div className="p-3 bg-white rounded-3 border text-center shadow-sm">
                  <div className="text-muted small" style={{ fontSize: '0.73rem' }}>Pasien Rawat Jalan (Hari ini)</div>
                  <div className="fw-bold text-primary fs-3">{patientStats.rawatJalan}</div>
                </div>
              </Col>
            </Row>

            <h6 className="fw-bold text-dark mb-2" style={{ fontSize: '0.85rem' }}>Distribusi Pasien Rawat Inap per Poliklinik / Departemen:</h6>
            <div className="bg-white rounded-3 border p-3 shadow-sm">
              {patientStats.departments.map((dept, i) => (
                <div key={i} className="d-flex justify-content-between align-items-center py-1.5 border-bottom last-border-0" style={{ fontSize: '0.8rem' }}>
                  <span className="fw-semibold text-dark"><i className="bi bi-caret-right-fill text-primary me-1"></i>{dept.name}</span>
                  <span className="badge rounded-pill bg-light text-dark border px-2.5 py-1">{dept.count} Pasien</span>
                </div>
              ))}
            </div>
          </Modal.Body>

          <Modal.Footer style={{ background: '#f1f5f9' }}>
            <Button variant="secondary" size="sm" onClick={() => setShowPatientModal(false)}>
              Tutup
            </Button>
          </Modal.Footer>
        </Modal>

        {/* ══════════════ MODAL DETAIL VERSI APLIKASI ══════════════ */}
        <Modal show={showVersionModal} onHide={() => setShowVersionModal(false)} centered size="lg">
          <Modal.Header closeButton style={{ background: 'linear-gradient(135deg, #0f172a 0%, #0d9488 100%)', color: '#fff' }}>
            <Modal.Title style={{ fontSize: '0.95rem', fontWeight: '800' }} className="d-flex align-items-center gap-2">
              <i className="bi bi-info-circle-fill text-warning fs-5"></i>
              <span>INFORMASI VERSI &amp; CATATAN RILIS SISTEM</span>
            </Modal.Title>
          </Modal.Header>

          <Modal.Body style={{ background: '#f8fafc', padding: '1.25rem' }}>
            {/* Header Ringkasan Versi */}
            <div
              className="d-flex align-items-center justify-content-between p-3 mb-3 rounded-3 shadow-xs"
              style={{ background: 'linear-gradient(135deg, #ffffff 0%, #f0fdf4 100%)', border: '1.5px solid #86efac' }}
            >
              <div className="d-flex align-items-center gap-3">
                <div
                  style={{
                    width: 48,
                    height: 48,
                    borderRadius: 12,
                    background: '#0d9488',
                    color: '#fff',
                    display: 'flex',
                    alignItems: 'center',
                    justifyContent: 'center',
                    fontSize: '1.5rem'
                  }}
                >
                  <i className="bi bi-patch-check-fill" />
                </div>
                <div>
                  <div className="fw-bold text-dark" style={{ fontSize: '1.05rem' }}>
                    {APP_VERSION.name}
                  </div>
                  <div className="text-muted small" style={{ fontSize: '0.75rem' }}>
                    Build: <strong>{APP_VERSION.buildNumber}</strong> &bull; Rilis: <strong>{APP_VERSION.releaseDate}</strong>
                  </div>
                </div>
              </div>

              <div className="text-end">
                <span className="badge rounded-pill px-3 py-2 text-white shadow-xs" style={{ background: '#0f766e', fontSize: '0.9rem', fontWeight: 800 }}>
                  v{APP_VERSION.version}
                </span>
                <div className="small text-success fw-bold mt-1" style={{ fontSize: '0.7rem' }}>
                  <i className="bi bi-shield-fill-check me-1" />{APP_VERSION.environment}
                </div>
              </div>
            </div>

            {/* Spesifikasi Teknis */}
            <Row className="g-2 mb-3">
              <Col sm={4}>
                <div className="bg-white p-2.5 rounded-3 border text-center shadow-xs">
                  <div className="text-muted small" style={{ fontSize: '0.68rem', textTransform: 'uppercase', fontWeight: 600 }}>Frontend Engine</div>
                  <div className="fw-bold text-dark" style={{ fontSize: '0.8rem' }}>React 19.x &amp; Vite/CRA</div>
                </div>
              </Col>
              <Col sm={4}>
                <div className="bg-white p-2.5 rounded-3 border text-center shadow-xs">
                  <div className="text-muted small" style={{ fontSize: '0.68rem', textTransform: 'uppercase', fontWeight: 600 }}>Backend Service</div>
                  <div className="fw-bold text-dark" style={{ fontSize: '0.8rem' }}>Python 3.13 Flask REST API</div>
                </div>
              </Col>
              <Col sm={4}>
                <div className="bg-white p-2.5 rounded-3 border text-center shadow-xs">
                  <div className="text-muted small" style={{ fontSize: '0.68rem', textTransform: 'uppercase', fontWeight: 600 }}>Database Cluster</div>
                  <div className="fw-bold text-dark" style={{ fontSize: '0.8rem' }}>MySQL (apot, simrs2, adm)</div>
                </div>
              </Col>
            </Row>

            {/* Riwayat Pembaruan / Changelog */}
            <h6 className="fw-bold text-dark mb-2 d-flex align-items-center gap-1.5" style={{ fontSize: '0.85rem' }}>
              <i className="bi bi-clock-history text-primary" /> Catatan Riwayat Pembaruan (Changelog):
            </h6>

            <div style={{ maxHeight: '280px', overflowY: 'auto' }} className="d-flex flex-column gap-2">
              {APP_VERSION.changelog.map((log, idx) => (
                <div
                  key={idx}
                  className="bg-white rounded-3 border p-3 shadow-xs"
                  style={{ borderLeft: idx === 0 ? '4px solid #0d9488' : '4px solid #94a3b8' }}
                >
                  <div className="d-flex justify-content-between align-items-center mb-1.5">
                    <span className="fw-bold text-dark" style={{ fontSize: '0.84rem' }}>
                      {log.version} {idx === 0 && <span className="badge bg-success ms-1" style={{ fontSize: '0.62rem' }}>Versi Aktif</span>}
                    </span>
                    <span className="text-muted small" style={{ fontSize: '0.72rem' }}>{log.date}</span>
                  </div>
                  <ul className="mb-0 ps-3" style={{ fontSize: '0.75rem', color: '#334155' }}>
                    {log.changes.map((c, i) => (
                      <li key={i} className="mb-0.5">{c}</li>
                    ))}
                  </ul>
                </div>
              ))}
            </div>
          </Modal.Body>

          <Modal.Footer style={{ background: '#f1f5f9', display: 'flex', justifyContent: 'space-between' }}>
            <span className="text-muted small" style={{ fontSize: '0.7rem' }}>
              &copy; {new Date().getFullYear()} RS Mary Cileungsi Hijau &bull; SIMRS Division
            </span>
            <Button variant="secondary" size="sm" onClick={() => setShowVersionModal(false)}>
              Tutup
            </Button>
          </Modal.Footer>
        </Modal>
      </div>
    </div>
  );
};

// ══════════════ STYLES ══════════════
const styles = {
  appContainer: {
    display: 'flex',
    flexDirection: 'column',
    height: '100vh',
    backgroundColor: '#f8fafc',
    backgroundImage: 'none',
    color: '#1e293b',
    overflow: 'hidden',
  },
  navbarCustom: {
    background: 'linear-gradient(135deg, #0f172a 0%, #1e293b 60%, #0d9488 100%)',
    padding: '0.45rem 1.2rem',
    flexShrink: 0,
    borderBottom: '1px solid rgba(255, 255, 255, 0.1)',
    boxShadow: '0 4px 20px rgba(15, 23, 42, 0.15)',
  },
  navLinkCustom: {
    color: 'rgba(226, 232, 240, 0.8)',
    fontSize: '0.78rem',
    fontWeight: '500',
    padding: '0.4rem 0.75rem',
    borderRadius: '8px',
    textDecoration: 'none',
    transition: 'all 0.2s ease',
    display: 'flex',
    alignItems: 'center',
  },
  navLinkActive: {
    color: '#ffffff',
    background: 'rgba(255, 255, 255, 0.16)',
    backdropFilter: 'blur(8px)',
    fontWeight: '600',
    boxShadow: 'inset 0 1px 1px rgba(255, 255, 255, 0.2)',
  },
  mainContent: {
    flex: 1,
    padding: '0.7rem 0.9rem',
    overflowY: 'auto',
    display: 'flex',
    flexDirection: 'column',
  },
  mainCard: {
    borderRadius: '14px',
    overflow: 'hidden',
    border: '1px solid #e2e8f0',
    background: '#ffffff',
  },
  cardHeader: {
    padding: '0.65rem 1rem',
    color: '#ffffff',
    fontWeight: '600',
    fontSize: '0.83rem',
    letterSpacing: '0.2px',
  },
  bgMenuHeader: {
    background: 'linear-gradient(135deg, #0f172a 0%, #1e293b 50%, #0d9488 100%)',
  },
  bgInfoHeader: {
    background: 'linear-gradient(135deg, #0f172a 0%, #1e293b 60%, #0284c7 100%)',
  },
  cardBody: {
    padding: '0.85rem',
    background: '#ffffff',
  },
  btnGradientBox: {
    border: '1px solid rgba(0, 0, 0, 0.04)',
    borderRadius: '12px',
    padding: '0.9rem 0.85rem',
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
    justifyContent: 'center',
    height: '110px',
    minHeight: '110px',
    maxHeight: '110px',
    textDecoration: 'none',
    fontWeight: '600',
    fontSize: '0.8rem',
    textAlign: 'center',
    transition: 'all 0.25s cubic-bezier(0.4, 0, 0.2, 1)',
    boxShadow: '0 4px 12px rgba(0, 0, 0, 0.04)',
    gap: '0.15rem',
  },

  infoBox: {
    background: 'linear-gradient(90deg, #f8fafc, #f1f5f9)',
    borderLeft: '4px solid #0d9488',
    borderRadius: '8px',
    padding: '0.85rem',
    fontSize: '0.8rem',
    fontWeight: '500',
    color: '#334155',
  },
  summaryCard: {
    border: 'none',
    borderRadius: '14px',
    padding: '0.8rem 1.2rem',
    color: 'white',
    display: 'flex',
    justifyContent: 'space-between',
    alignItems: 'center',
    boxShadow: '0 4px 16px rgba(0, 0, 0, 0.06)',
  },
  sum1: { background: 'linear-gradient(135deg, #0d9488 0%, #0f766e 100%)' },
  sum2: { background: 'linear-gradient(135deg, #0284c7 0%, #0369a1 100%)' },
  sum3: { background: 'linear-gradient(135deg, #6366f1 0%, #4f46e5 100%)' },
  sumValue: { fontSize: '1.45rem', fontWeight: '700' },
  sumLabel: { fontSize: '0.76rem', opacity: '0.9' },
  iconWrap: { background: 'rgba(255, 255, 255, 0.22)', padding: '6px 10px', borderRadius: '10px', fontSize: '1.15rem' }
};

export default Home;